import { httpClient } from "../../helpers/httpClient";
import { APP_API_URL, APP_API_VERSION } from "../../helpers/configuration";

export default {
  getSettings({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/settings`;
    return httpClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSettings", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  updateSettings({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/settings`;
    return httpClient
      .patch(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Settings updated" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Update error" }, { root: true });
        console.log(error);
      });
  },
  updateSettingsAutoTopUp({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/settings:updateAutoTopup`;
    return httpClient
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setSuccess", { data: "Auto Topup updated" }, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Update error" }, { root: true });
        console.log(error);
      });
  }
};
